import { Breakpoint } from '@altibox/lte-salgskanaler-design-system-component-lib';
import React, { FunctionComponent } from 'react';

import { i18n } from 'src/i18n';
import { selectItemQuantitiesFromCart } from 'src/state/cart/selectors';
import { goToStepActionCreator } from 'src/state/order/action-creators/go-to-step-action-creator';
import { OrderStep } from 'src/state/order/types';
import { useAppDispatch, useAppSelector } from 'src/state/thunk-api';
import { Cart } from 'src/components/cart/cart';

import { StyledButton, StyledText } from './cart-mobile.styled';

export const CartMobile: FunctionComponent = () => {
  const dispatch = useAppDispatch();
  const itemQuantitiesFromCart = useAppSelector(selectItemQuantitiesFromCart);

  const handleButtonClick = () => {
    dispatch(goToStepActionCreator(OrderStep.SUMMARY));
  };

  return (
    <StyledButton scheme="neutral" onClick={handleButtonClick}>
      <StyledText maxBreakpoint={Breakpoint.MOBILE} component="p" variant="headline5">
        {i18n.component.cart.notEmpty.cta}
      </StyledText>
      <Cart cartItemCount={itemQuantitiesFromCart.quantityTotal} />
    </StyledButton>
  );
};
